import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const MANAGE_STUDENTS_STUDENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/manage-students',
        iconClass: 'fas fa-graduation-cap',
        name: '::Menu:Students',
        layout: eLayoutType.empty,
        requiredPolicy: 'Mandir.Students',
      },
    ]);
  };
}
